import React from "react";
import PropTypes from "prop-types";
import {DirectPostContainer} from "./DirectPostContainer";
import Page from "../components/BaseComponents/Page/Page";
import {FaSolidIcon} from "../components/FontAwesomeIcons";
import {DirectProductContainer} from "./DirectProductContainer";

export class DirectProductPage extends React.Component{

    constructor(props) {
        super(props);
    }

    render(){
        return (
            <Page
                title={''}
                leftIcon={<FaSolidIcon name={"chevron-left"}/>}
                
                onLeftIconClick={this.props.onDismiss}
                active={true}
            >
                <DirectProductContainer
                    id_prodotto={this.props.id_prodotto}
                    useDownloadBanner={false}
                    useMetaTags={false}
                    useActionBar={true}
                    onAppOpen={this.props.onAppOpen}
                    onAppAdd={this.props.onAppAdd}
                />
            </Page>
        )
    }

}

DirectPostContainer.propTypes = {
    id_prodotto: PropTypes.any,
    onDismiss: PropTypes.func,
    onAppOpen: PropTypes.func,
    onAppAdd: PropTypes.func
}
